var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pos_settings" },
    _vm._l(_vm.pos_params, function (key_val, key_name) {
      return key_name.length > 0 && key_name != "id"
        ? _c(
            "div",
            {
              key: key_name,
              staticClass: "form-group pos-setting-item",
              class: {
                "bool-group": _vm.is_bool_settings(
                  key_name,
                  _vm.pos_params[key_name]
                ),
              },
            },
            [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__t(key_name.toUpperCase())) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              !_vm.is_special_settings(key_name, _vm.pos_params[key_name])
                ? _c(
                    "div",
                    {
                      staticClass:
                        "input-group input-group-lg bg-white shadow-inset-2 with_icon",
                    },
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("b-form-input", {
                        key: "input_" + key_name,
                        staticClass: "form-control bg-transparent pl-5",
                        attrs: { debounce: "300", id: "pos_param_" + key_name },
                        on: {
                          update: function ($event) {
                            return _vm.on_change_value(key_name)
                          },
                        },
                        model: {
                          value: _vm.pos_params[key_name],
                          callback: function ($$v) {
                            _vm.$set(_vm.pos_params, key_name, $$v)
                          },
                          expression: "pos_params[key_name]",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.is_bool_settings(key_name, _vm.pos_params[key_name])
                ? _c(
                    "div",
                    { staticClass: "bool-setting" },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          id: "bool_" + key_name,
                          "button-variant": "outline-primary",
                          options: [
                            { text: _vm.__t("YES"), value: true },
                            { text: _vm.__t("NO"), value: false },
                          ],
                          name: "radios-btn-" + key_name,
                          buttons: "",
                        },
                        on: {
                          update: function ($event) {
                            return _vm.on_change_value(key_name)
                          },
                        },
                        model: {
                          value: _vm.pos_params[key_name],
                          callback: function ($$v) {
                            _vm.$set(_vm.pos_params, key_name, $$v)
                          },
                          expression: "pos_params[key_name]",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.is_array_settings(_vm.pos_params[key_name])
                ? _c(
                    "div",
                    [
                      _c("v-select", {
                        key: "array_" + key_name,
                        staticClass: "imc_reasons",
                        attrs: { taggable: "", multiple: "" },
                        on: {
                          input: function ($event) {
                            return _vm.on_change_value(key_name)
                          },
                        },
                        model: {
                          value: _vm.pos_params[key_name],
                          callback: function ($$v) {
                            _vm.$set(_vm.pos_params, key_name, $$v)
                          },
                          expression: "pos_params[key_name]",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              key_name == "db_params"
                ? _c(
                    "div",
                    [
                      _c("pos_db", {
                        attrs: { cur_db: _vm.pos_params[key_name] },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass:
            "input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3",
        },
        [
          _c("span", { staticClass: "icon-stack fs-xxl" }, [
            _c("i", { staticClass: "base-7 icon-stack-3x color-primary-500" }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fal fa-database icon-stack-1x text-white",
            }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }